
import React, { useCallback, useEffect } from "react";
import { Box, Flex, Paper, Title, createStyles } from "@mantine/core";
import { useMedplum } from "@medplum/react";
import SimpleLineChart from "./Last";
import uparrow from "../../assets/img/uparrow.svg";

const useStyles = createStyles((theme) => ({
  infoCard: {
    borderRadius: theme.radius.sm,
    minHeight: "170px",
    maxWidth: "260px",
    padding: theme.spacing.md,
    flexWrap: "wrap",
    display: "flex",
  },
  title: {
    fontSize: "36px",
    fontWeight: 700,
    flexWrap: "wrap",
  },
  growth: {
    color: "#14923E",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "22px",
  },
}));

interface DashboaedInfoProps {
  Heading: string;
  subData: number;
  growthInPercent: number;
  src1: any;
  last7DaysData: any;
}

export const DashboardInfo: React.FC<DashboaedInfoProps> = ({
  Heading,
  subData,
  growthInPercent,
  src1,
  last7DaysData,
}) => {
  const { classes } = useStyles();
  const medplum = useMedplum();

  const loadResults = useCallback(
    (options?: RequestInit) => {
      medplum.search("Patient", options);
    },
    [medplum]
  );

  useEffect(() => {
    loadResults();
  }, []);

  return (
    
      <Paper className={classes.infoCard}>
        <Box>
          <Flex gap={"10px"} align={"center"} h={"40px"}>
            <img src={src1} alt="" />
            <Title className={classes.title} fz="lg" fw="600" lh={"21px"}>
              {Heading}
            </Title>
          </Flex>
          <Box style={{ display: "flex", flexDirection: "row" }}>
            <Box style={{ marginRight: "33px" }}>
              <Title ta={"start"} className={classes.title} fw="bold">
                {subData}
              </Title>
              <Box style={{ display: "flex", flexDirection: "row" }}>
                <Box style={{ marginRight: "8.5px" }}>
                  <img src={uparrow} alt="" />
                </Box>
                <Box className={classes.growth}>{growthInPercent}%</Box>
              </Box>
            </Box>
            <Box
              style={{
                width: "100%",
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-end",
              }}
            >
              <Box
                style={{
                  height: "52px",
                  width: "132px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <SimpleLineChart data={last7DaysData} color="green" />
              </Box>
            </Box>
          </Box>
        </Box>
      </Paper>
   
  );
};


